import { RefundsFailReasonsEnum } from "./refunds-fail-reasons.enum";

interface IRefundsFailReason {
  shortReason: string;
  longReason: string;
  creditGuardCodes: number[];
  reasonType: RefundsFailReasonsEnum;
}

const allRefundsFailReasons: IRefundsFailReason[] = [
  {
    creditGuardCodes: [310],
    longReason: `מצב זה יכול להווצר ממחיקת עסקת החיוב, נסו לבדוק שהעסקה עדיין קיימת.`,
    reasonType: RefundsFailReasonsEnum.NoMatchingTransactionsFound,
    shortReason: "אין עסקת חיוב התואמת את הזיכוי",
  },
  {
    creditGuardCodes: [321],
    longReason: `יתכן שעקב הנחה או שינוי בתמחור ההורה שילם פחות מהמחיר
     המקורי של הארוע, שימו לב למחיר ששולם על האורוע על ידי החניך.`,
    reasonType: RefundsFailReasonsEnum.RefundAboveLimit,
    shortReason: "סכום הזיכוי גדול או קטן מסכום החיוב",
  },
];

export const RefundsFailReasons = (
  failText: string
): IRefundsFailReason | null => {
  const creditGuardText = failText.match(/CreditGuardError: #\d{0,9}/);
  if (!creditGuardText) {
    return null;
  }
  const creditGuardCode = creditGuardText[0]
    ? +creditGuardText[0].replace("CreditGuardError: #", "")
    : 0;
  const relatedFailReason = allRefundsFailReasons.find((r) =>
    r.creditGuardCodes.includes(creditGuardCode)
  );
  return relatedFailReason || null;
};



// WEBPACK FOOTER //
// ./src/app/admin/payments_refunds/refund-fail-reasons/refunds-fail-reasons.ts